"use client";
import { Fragment } from "react";
import PageLayout from "@/layouts/pageLayout";
import PillarsComponent from "./components/pillars";
import HeroComp from "./components/hero";
import VisionComp from "./components/futureVision";

const AboutUsPage = () => {
  return (
    <Fragment>
      <HeroComp />
      <PageLayout
        showCertificates
        showCustomers
        showFeatures
        showTechPartners
        showContactForm
        spacing={20}
      >
        <VisionComp />
        <PillarsComponent />
      </PageLayout>
    </Fragment>
  );
};

export default AboutUsPage;
